document.addEventListener('DOMContentLoaded', function () {
  // header scroll state
  var header = document.getElementById('siteHeader');
  var toTop = document.getElementById('toTop');
  window.addEventListener('scroll', function () {
    if (header) header.classList.toggle('scrolled', window.scrollY > 40);
    if (toTop) toTop.classList.toggle('show', window.scrollY > 500);
  });

  // scroll reveal
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  // animated counters
  var counters = document.querySelectorAll('.num[data-count]');
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var target = parseFloat(el.dataset.count);
          var isDecimal = target % 1 !== 0;
          var cur = 0;
          var step = target / 40;
          var tick = function () {
            cur += step;
            if (cur >= target) { el.textContent = isDecimal ? target.toFixed(1) : Math.round(target); return; }
            el.textContent = isDecimal ? cur.toFixed(1) : Math.round(cur);
            requestAnimationFrame(tick);
          };
          tick();
          cio.unobserve(el);
        }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  // toast
  window.showToast = function (msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(window._toastTimer);
    window._toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  };

  // wishlist toggle (visual only, no backend storage)
  document.querySelectorAll('.wishlist, .wishlist-btn').forEach(function (el) {
    el.addEventListener('click', function () {
      el.classList.toggle('active');
      el.style.background = el.classList.contains('active') ? 'var(--pink)' : 'rgba(255,255,255,0.9)';
      showToast(el.classList.contains('active') ? 'Added to wishlist ♥' : 'Removed from wishlist');
    });
  });

  // faq accordion
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (f) { f.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });

  // category filter
  document.querySelectorAll('.cat-chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var cat = chip.dataset.cat;
      document.querySelectorAll('.cat-chip').forEach(function (c) { c.classList.remove('active'); });
      chip.classList.add('active');
      document.querySelectorAll('.cat-block').forEach(function (block) {
        block.style.display = (cat === 'all' || block.dataset.cat === cat) ? '' : 'none';
      });
    });
  });

  // mobile menu
  window.toggleMenu = function () {
    var m = document.getElementById('mobileMenu');
    var o = document.getElementById('overlay');
    if (m) m.classList.toggle('open');
    if (o) o.classList.toggle('open');
  };
  var overlay = document.getElementById('overlay');
  if (overlay) overlay.addEventListener('click', window.toggleMenu);

  // whole-card click -> product page
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.product-card[data-url]');
    if (!card) return;
    if (e.target.closest('button, a')) return;
    window.location.href = card.dataset.url;
  });

  // ---------- CART DRAWER ----------
  var cartDrawer = document.getElementById('cartDrawer');
  var cartDrawerOverlay = document.getElementById('cartDrawerOverlay');

  function fmtMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function renderCartDrawer(cart) {
    var body = document.getElementById('cartDrawerBody');
    var foot = document.getElementById('cartDrawerFoot');
    var count = document.getElementById('cartDrawerCount');
    var headerCount = document.getElementById('cartCount');
    if (headerCount) headerCount.textContent = cart.item_count;
    if (!body) return;
    if (count) count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-drawer-empty">Your cart is empty 🐾</p>';
      if (foot) foot.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function (item, i) {
      html += '<div class="cart-drawer-item">'
        + (item.image ? '<img src="' + esc(item.image) + '" alt="" loading="lazy">' : '')
        + '<div class="cart-drawer-item-info"><h4>' + esc(item.product_title) + '</h4>'
        + (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="variant">' + esc(item.variant_title) + '</p>' : '')
        + '<div class="cart-drawer-qty">'
        + '<button data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>'
        + '<span>' + item.quantity + '</span>'
        + '<button data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>'
        + '</div></div>'
        + '<div class="cart-drawer-item-right"><span class="price">' + fmtMoney(item.final_line_price) + '</span>'
        + '<button class="cart-drawer-remove" data-line="' + (i + 1) + '" data-qty="0">Remove</button></div>'
        + '</div>';
    });
    body.innerHTML = html;
    var sub = document.getElementById('cartDrawerSubtotal');
    if (sub) sub.textContent = fmtMoney(cart.items_subtotal_price);
    if (foot) foot.style.display = '';
  }

  window.refreshCartDrawer = function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer);
  };

  window.openCartDrawer = function () {
    if (!cartDrawer) return;
    window.refreshCartDrawer();
    cartDrawer.classList.add('open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  window.closeCartDrawer = function () {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.remove('open');
    document.body.style.overflow = '';
  };

  // qty +/- and remove inside the drawer
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.cart-drawer button[data-line]');
    if (!b) return;
    b.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(b.dataset.line), quantity: Number(b.dataset.qty) })
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () { showToast('Could not update cart'); b.disabled = false; });
  });

  // cart icon opens the drawer (except when already on the cart page)
  document.querySelectorAll('.cart-icon').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (location.pathname.indexOf('/cart') === 0) return;
      e.preventDefault();
      window.openCartDrawer();
    });
  });

  // Escape key closes the drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.closeCartDrawer();
  });
  // ---------- END CART DRAWER ----------

  // add to cart via Shopify AJAX API
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = btn.dataset.variantId;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        btn.textContent = 'Added ✓';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
        window.openCartDrawer();
      })
      .catch(function (err) {
        showToast((err && err.description) || 'Could not add to cart');
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });

  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var el = document.getElementById('cartCount');
      if (el) el.textContent = cart.item_count;
    });
  }
  updateCartCount();
});
